import React from 'react';

const PaginationButton = ({ handlePagination, url, index }) => {
	if (handlePagination && url && index) {
		return (
			<li className="mx-1" data-testid="pagination-button">
				<a
					href={url}
					onClick={(e) => {
						e.preventDefault();
						handlePagination(url);
					}}
					className="pagination__list-item-link flex justify-center items-center cta cta-secondary btn btn-secondary text-sm text-center font-body bg-white rounded border-gray-40 p-0">
					{index}
				</a>
			</li>
		);
	}

	return null;
};

export default PaginationButton;
